import { useState, useEffect, useRef } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import TechDivision from './components/TechDivision/TechDivision';
import ConstructionDivision from './components/ConstructionDivision/ConstructionDivision';
import ConstructionGallery from './components/ConstructionGallery/ConstructionGallery';
import SoftwareGallery from './components/SoftwareGallery/SoftwareGallery';

import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ServicePage from './components/ServicePage/ServicePage';
import AdBanner from './components/AdBanner/AdBanner';

function App() {
  const [showTop, setShowTop] = useState(false);
  const [activePage, setActivePage] = useState(null);
  const scrollAfterBack = useRef(null);
  const [division, setDivision] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('division') === 'construction' ? 'construction' : 'software';
  });

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const search = division === 'construction' ? '?division=construction' : window.location.pathname;
    window.history.replaceState(null, '', search);
    window.scrollTo({ top: 0, behavior: 'instant' });
    setShowTop(false);
    setActivePage(null);
  }, [division]);

  useEffect(() => {
    if (activePage) {
      window.scrollTo({ top: 0, behavior: 'instant' });
      setShowTop(false);
    } else if (scrollAfterBack.current) {
      const id = scrollAfterBack.current;
      scrollAfterBack.current = null;
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }, [activePage]);

  return (
    <ThemeProvider>
      <div className="App">
        <Navbar division={division} setDivision={setDivision} />

        {division === 'software' && activePage ? (
          <ServicePage
            slug={activePage}
            division={division}
            onBack={() => {
              scrollAfterBack.current = 'tech';
              setActivePage(null);
            }}
            onContact={() => {
              scrollAfterBack.current = 'contact';
              setActivePage(null);
            }}
          />
        ) : division === 'software' ? (
          <>
            <Hero setDivision={setDivision} />
            <About />
            <AdBanner images={['/ads/kat993.png', '/ads/kat994.png', '/ads/kat995.png', '/ads/kat996.png']} />
            <TechDivision setActivePage={setActivePage} />
            <SoftwareGallery />
            <Contact division={division} />
            <Footer division={division} />
          </>
        ) : (
          <>
            <ConstructionDivision />
            <AdBanner
              images={['/ads_construction/construction1.jpg', '/ads_construction/construction2.jpg', '/ads_construction/construction3.jpg', '/ads_construction/construction4.jpg']}
              aspectRatio="912 / 1136"
            />
            <ConstructionGallery />
            <Contact division={division} />
            <Footer division={division} />
          </>
        )}

        {/* Scroll to top */}
        <button
          className={`scroll-top-btn${showTop ? ' scroll-top-btn--visible' : ''}`}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      </div>
    </ThemeProvider>
  );
}

export default App;
